import React from 'react';
import { I18nextProvider, translate } from 'react-i18next';
import {
  ExperimentsProvider,
  withExperiments,
} from '@wix/wix-experiments-react';
import i18n from '../../config/i18n';
import styles from './App.st.css';
import { TPAComponentsProvider } from 'wix-ui-tpa/TPAComponentsConfig';

export default class AppRoot extends React.Component {
  constructor(props) {
    super(props);
    this.onMessage = this.onMessage.bind(this);
  }

  onMessage = ({ data } = {}) => {
    if (data.type === 'refreshData') {
      const { refreshSets } = this.props;
      refreshSets(data.data);
    }
    if (data.type === 'goToPage') {
      const { goToPage } = this.props;
      goToPage(data.data);
    }
  };

  componentDidMount() {
    window.addEventListener('message', this.onMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.onMessage);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.time !== nextProps.time) {
      window.top.postMessage({
          type: 'pageLoaded',
          currentPage: nextProps.currentPage || null,
        },
        '*',
      );
    }
  }

  render() {
    const { locale, experiments, mobile, ...rest } = this.props;
    return (
      <I18nextProvider i18n={i18n(locale)}>
        <ExperimentsProvider options={{ experiments }}>
          <TPAComponentsProvider value={{ mobile }}>
            <App {...rest} />
          </TPAComponentsProvider>
        </ExperimentsProvider>
      </I18nextProvider>
    );
  }
}

class AppComp extends React.Component {
  componentDidMount() {
    const { reportAppLoaded } = this.props;
    try {
      reportAppLoaded && reportAppLoaded();
    } catch (e) {
      console.log('Failed to report app loaded');
    }
  }

  render() {
    return (
      <div className={styles.header}>
        <h2 className={styles.h2}>Albums Gallery Place holder</h2>
      </div>
    );
  }
}

export const App = withExperiments(translate()(AppComp));
